import { sendError } from '@components/Noti';
import memoizeOne from 'memoize-one';

const getSize = (
  src: string | File
): Promise<{ width: number; height: number } | null> => {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () =>
      resolve({
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
    image.onerror = () => {
      sendError('图片宽高读取错误，请重试');
      resolve(null);
    };

    if (typeof src === 'string') {
      image.src = src;
    } else {
      const reader = new FileReader();
      reader.onload = (event) => {
        image.src = event.target?.result as string;
      };
      reader.onerror = () => {
        sendError('图片文件读取错误，请重试');
        resolve(null);
      };
      reader.readAsDataURL(src);
    }
  });
};

export default memoizeOne(getSize);
